export const DC_SET_CASE_TYPE_MAPPING = 'DC_SET_CASE_TYPE_MAPPING';
export const DC_SET_REDIRECT_HOME = 'DC_SET_REDIRECT_HOME';



// WEBPACK FOOTER //
// ./src/pages/dcimport/state/fileconfig/types.js